import React from "react";
import { motion } from "framer-motion";
import { spring } from "../theme/motion";

// Heights, paddings and radius match the DashboardV2 Button so CRM controls
// line up with the rest of the app (28 / 32 / 36, 6px radius).
const sizes = {
  sm: { height: 28, padding: "0 10px", fontSize: 12 },
  md: { height: 32, padding: "0 12px", fontSize: 14 },
  lg: { height: 36, padding: "0 14px", fontSize: 14 },
};

const styleFor = (variant) => {
  if (variant === "primary") return { background: "var(--crm-primary)", color: "var(--crm-primary-text)", border: "1px solid transparent" };
  if (variant === "secondary") return { background: "var(--color-bg-surface)", color: "var(--color-text-primary)", border: "1px solid var(--color-border-strong)" };
  if (variant === "ghost") return { background: "transparent", color: "var(--color-text-secondary)", border: "1px solid transparent" };
  if (variant === "danger") return { background: "var(--crm-danger)", color: "#fff", border: "1px solid transparent" };
  return {};
};

export default function Button({ variant = "primary", size = "md", children, disabled, leftIcon, rightIcon, style, ...rest }) {
  const s = sizes[size];
  return (
    <motion.button
      whileTap={disabled ? {} : { scale: 0.97 }}
      transition={spring.instant}
      disabled={disabled}
      style={{ ...styleFor(variant), height: s.height, padding: s.padding, fontSize: s.fontSize, borderRadius: 6, fontWeight: 500, display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8, cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.5 : 1, transition: "background 120ms ease", ...style }}
      {...rest}
    >
      {leftIcon}{children}{rightIcon}
    </motion.button>
  );
}
